export default __webpack_public_path__ + "static/media/add-tag.cc65d7ee.svg";